export const FILTER_CHANGE = 'FILTER_CHANGE';
export const FILTERS_LOADED_FROM_URL = 'FILTERS_LOADED_FROM_URL';
export const CLEAR_ALL_FILTERS = 'CLEAR_ALL_FILTERS';
export const FILTER_TAG_REMOVED = 'FILTER_TAG_REMOVED';
export const CLEAR_SERVICES_FILTERS_CLICKED = 'CLEAR_SERVICES_FILTERS_CLICKED';
